import axios from "axios";
// import fileDownload from "js-file-download";
import Cookies from "js-cookie";
import { message } from "antd";
import { navigate, useNavigate } from "react-router-dom";
import API_MANAGER from "../API";

const baseURL = "https://staging-recruiter.cinchy.me/";

// Token refresh state management
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onTokenRefreshed = (token) => {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
};

let HELPERS = {
  log: (...args) => {
    if (process.env.NODE_ENV !== "production") {
    }
  },
  error: (...args) => {
    if (process.env.NODE_ENV !== "production") {
    }
  },
  getCookie: (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  },

  request: (config) => {
    config.headers = config.headers ? config.headers : {};
    const csrfTokenEl = document.querySelector("[name=csrfmiddlewaretoken]");
    const csrfToken =
      HELPERS.getCookie("csrftoken") || (csrfTokenEl && csrfTokenEl.value);
    // if (csrfToken) {
    //   config.headers["X-CSRFToken"] = csrfToken;
    // }

    return axios
      .request(config)
      .then((response) => {
        localStorage.removeItem("session");
        localStorage.removeItem("network");
        return response;
      })
      .catch(async (err) => {
        console.log(err, "--------------------------------");
        if (err?.response?.status === 401) {
          // Try to refresh token if this is a secure request
          const refreshToken = Cookies.get("refresh_token");
          if (refreshToken && config.headers?.Authorization) {
            try {
              // If already refreshing, wait for it to complete
              if (isRefreshing) {
                return new Promise((resolve, reject) => {
                  subscribeTokenRefresh((token) => {
                    if (token) {
                      config.headers["Authorization"] = `Bearer ${token}`;
                      axios.request(config).then(resolve).catch(reject);
                    } else {
                      reject(err);
                    }
                  });
                });
              }
              
              // Start refresh process
              await HELPERS.refreshAccessToken(refreshToken);
              // Retry the original request with new token
              const newAccessToken = Cookies.get("access_token");
              if (newAccessToken) {
                config.headers["Authorization"] = `Bearer ${newAccessToken}`;
                return axios.request(config);
              }
            } catch (refreshError) {
              console.log("Token refresh failed:", refreshError);
            }
          }
          
          // If refresh failed or no refresh token, show error message and redirect to login
          const errMsg = err?.response?.data?.message;
          const errorMessage = typeof errMsg === 'string' ? errMsg : (errMsg?.message || "Your session has expired. Please log in again.");
          message.error(errorMessage);
          
          const Email = localStorage.getItem("email");
          const Password = localStorage.getItem("password");
          localStorage.clear();
          if (Email && Password) {
            localStorage.setItem("email", Email);
            localStorage.setItem("password", Password);
          }
          localStorage.removeItem("network");
          localStorage.setItem("session", "Yes");
          
          // Reject the promise so catch blocks can handle it
          return Promise.reject(err);
        } else if (err?.response?.status === 403) {
          // Handle 403 Forbidden errors
          const errMsg403 = err?.response?.data?.message;
          const errorMessage = typeof errMsg403 === 'string' ? errMsg403 : (errMsg403?.message || "You do not have permission to access this resource.");
          message.error(errorMessage);
          return Promise.reject(err);
        } else if (err?.code === "ERR_NETWORK") {
          console.log(err);
          localStorage.setItem("network", "Yes");
          localStorage.removeItem("session");
          return Promise.reject(err);
        } else {
          localStorage.removeItem("network");
          localStorage.removeItem("session");
          throw err;
        }
      });
  },
  secureRequest: async (config) => {
    config.headers = config.headers ? config.headers : {};
    let accessToken = Cookies.get("access_token");

    if (accessToken === undefined) {
      const refreshToken = Cookies.get("refresh_token");
      if (refreshToken === undefined) {
        // No refresh token available, redirect to login
        const Email = localStorage.getItem("email");
        const Password = localStorage.getItem("password");
        localStorage.clear();
        if (Email && Password) {
          localStorage.setItem("email", Email);
          localStorage.setItem("password", Password);
        }
        localStorage.setItem("session", "Yes");
        return Promise.reject(new Error("No refresh token available"));
      }
      // Try to refresh the token
      try {
        await HELPERS.refreshAccessToken(refreshToken);
        accessToken = Cookies.get("access_token");
      } catch (error) {
        // Refresh failed, redirect to login
        const Email = localStorage.getItem("email");
        const Password = localStorage.getItem("password");
        localStorage.clear();
        if (Email && Password) {
          localStorage.setItem("email", Email);
          localStorage.setItem("password", Password);
        }
        localStorage.setItem("session", "Yes");
        return Promise.reject(error);
      }
    }
    config.headers["Authorization"] = `Bearer ${accessToken} `;
    const clientId = localStorage.getItem("clientId");
    if (clientId) config.headers["clientId"] = clientId;
    return HELPERS.request(config);
  },
  converToFormData: (obj, rootName, ignoreList) => {
    var formData = new FormData();
    function appendFormData(data, root) {
      if (!ignore(root)) {
        root = root || "";
        if (data instanceof File) {
          formData.append(root, data);
        } else if (Array.isArray(data)) {
          for (var i = 0; i < data.length; i++) {
            appendFormData(data[i], root + "[" + i + "]");
          }
        } else if (typeof data === "object" && data) {
          for (var key in data) {
            if (data.hasOwnProperty(key)) {
              if (root === "") {
                appendFormData(data[key], key);
              } else {
                appendFormData(data[key], root + "." + key);
              }
            }
          }
        } else {
          if (data !== null && typeof data !== "undefined") {
            formData.append(root, data);
          }
        }
      }
    }
    function ignore(root) {
      return (
        Array.isArray(ignoreList) &&
        ignoreList.some(function (x) {
          return x === root;
        })
      );
    }
    appendFormData(obj, rootName);
    return formData;
  },
  //   handleDownload: (url, filename) => {
  //     let type = url.split("?")[0];
  //     type = type.split(".");
  //     const name = filename + "." + type[type.length - 1];
  //     axios
  //       .get(url, {
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           "Access-Control-Allow-Methods": "GET",
  //           "Content-Type": "application/json",
  //         },
  //         responseType: "blob",
  //       })
  //       .then((res) => {
  //         fileDownload(res.data, name);
  //       })
  //       .catch((err) => {
  //         message.warn("Something went wrong");
  //       });
  //   },
  debounce: (fn, wait) => {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  },
  //   downloadFile: (response) => {
  //     try {
  //       let fileName = null;
  //       const fieldToFind = "filename";
  //       const headerValues = response.headers["content-disposition"];
  //       if (headerValues && headerValues !== "") {
  //         const headerValuesArray = headerValues.split(";");
  //         for (let i = 0; i < headerValuesArray.length; i++) {
  //           const headerValue = headerValuesArray[i].trim();
  //           // Does this header value string begin with the name we want?
  //           if (
  //             headerValue.substring(0, fieldToFind.length + 1) ===
  //             fieldToFind + "="
  //           ) {
  //             fileName = headerValue.substring(fieldToFind.length + 1);
  //             break;
  //           }
  //         }
  //       }
  //       var blob = new Blob([response?.data]);
  //       fileDownload(blob, `${fileName}`);
  //     } catch (err) {
  //       message.warn("Something went wrong");
  //     }
  //   },
  deleteCookie: (name) => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
  refreshAccessToken: async (refreshToken) => {
    // If already refreshing, return the existing promise
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          if (token) {
            resolve({ data: { data: { accessToken: token } } });
          } else {
            reject(new Error("Token refresh failed"));
          }
        });
      });
    }

    isRefreshing = true;
    
    try {
      const data = {
        refreshToken: refreshToken,
      };
      const response = await API_MANAGER.refreshToken(data);
      
      // Update access token
      if (response?.data?.data?.accessToken) {
        Cookies.set("access_token", response.data.data.accessToken, {
          expires: 3 / 24, // 1 hour
        });
      }
      
      // Update refresh token if provided
      if (response?.data?.data?.refreshToken) {
        Cookies.set("refresh_token", response.data.data.refreshToken, {
          expires: 3.25 / 24, // 3 hours 15 minutes
        });
      }
      
      // Update expire time
      let expireTime = new Date().getTime() + 3 * 3600 * 1000; // 3 hours
      localStorage.setItem("expireTime", expireTime);
      
      // Notify all subscribers that token has been refreshed
      onTokenRefreshed(response?.data?.data?.accessToken);
      isRefreshing = false;
      
      return response;
    } catch (err) {
      console.error("Token refresh failed:", err);
      // Notify all subscribers that refresh failed
      onTokenRefreshed(null);
      isRefreshing = false;
      throw err;
    }
  },
  
  // Utility function to manually test refresh token
  testRefreshToken: async () => {
    const refreshToken = Cookies.get("refresh_token");
    if (!refreshToken) {
      console.log("No refresh token found");
      return false;
    }
    
    try {
      const response = await HELPERS.refreshAccessToken(refreshToken);
      console.log("Token refresh successful:", response);
      return true;
    } catch (error) {
      console.error("Token refresh failed:", error);
      return false;
    }
  },
};

export default HELPERS;
